
export class FileParam {
    constructor(state) {
        if (state == null)
            state = {};

        const { id = 0, editionId = null, articleId = null, type = FileType.CompletePdf, fileName = '', gridfsId = '', description = '', isMainImage = null, pageNumber = 0 } = state;

        this.id = id;
        this.editionId = editionId;
        this.articleId = articleId;
        this.type = type;
        this.fileName = fileName;
        this.gridfsId = gridfsId;
        this.description = description;
        this.isMainImage = isMainImage;
        this.pageNumber = pageNumber;
    }
}

export const FileType = {
    CompletePdf : 0,
    CompleteTxt: 1,
    Cover: 2,
    Page: 3,
    Image:4,
    Audio: 5
}


// WEBPACK FOOTER //
// ./src/APIModels/FileParam.js